import { UP, DOWN } from './dnd-constants';

export const calculateDropOffset = (clientRect, clientOffset) => {
  const midPoint = clientRect.y + clientRect.height / 2;
  return clientOffset.y > midPoint ? DOWN : UP;
};
